/**
  * 时间周期工具
    @author weili
  * @date 2023-06-21
  
  */
import moment from 'moment'
/**
 * @description 今天昨天明天
 * @param {Number} v 3为昨天，6为今天，9为明天
 */
export function getDay(v) {
    let b = 24 * 60 * 60 * 1000 //一天的时间
    let day = new Date() //当天的时间
    v == 3 ? day.setTime(day.getTime() - b) : v == 6 ? day.setTime(day.getTime()) : day.setTime(day.getTime() + b)
    let dayMon = day.getMonth() + 1 >= 10 ? day.getMonth() + 1 : '0' + (day.getMonth() + 1)
    let dayDat = day.getDate() + 1 >= 10 ? day.getDate() : '0' + day.getDate()
    let s = day.getFullYear() + '-' + dayMon + '-' + dayDat
    return s
  }

/**
 * @description 得到本、上、下周的起始、结束日期
*  @param {String} type s代表开始时间，e代表结束时间
 * @param {Number} n 不传或0代表本周，-1代表上周，1代表下周
 */
  export function  getWeek(type,n) { // 周
    let now = new Date()
    let day = now.getDay() //返回星期几的某一天;
    if (type == 's') {
      if (n == 1) {
        let dayNumber = day == 0 ? 0 : 7 - day
        now.setDate(now.getDate() + dayNumber + 1)
      } else if (n == -1) {
        let dayNumber = day == 0 ? 6: day - 1
        now.setDate(now.getDate() - dayNumber - 7)
      } else {
        let dayNumber = day == 0 ? 6: day - 1
        now.setDate(now.getDate() - dayNumber)
      }
    } else {
      if (n == 1) {
        let dayNumber = day == 0 ? 0 : 7 - day
        now.setDate(now.getDate() + dayNumber + 1 + 6) // 在周开始的日期上+6天=周结束
      } else if (n == -1) {
        let dayNumber = day == 0 ? 6: day - 1
        now.setDate(now.getDate() - dayNumber - 7 + 6)
      } else {
        let dayNumber = day == 0 ? 0: 7 - day
        now.setDate(now.getDate() + dayNumber)
      }
    }
    let date = now.getDate()
    let month = now.getMonth() + 1

    let s = now.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
    return s
  }

/**
 * @description 得到本月、上月、下月的起始、结束日期
 * @param {String} type s代表开始时间，e代表结束时间
 * @param {Number} n 不传或0代表本月，-1代表上月，1代表下月
 */
  export function getMonth(type,n) {
    if (type == 's') {
        return Timetools(1, n)
    }else{
        return Timetools(0, n)
    }
  }

  function Timetools(num, n) {
    var now = new Date()
    var year = now.getFullYear()
    var month = now.getMonth() + 1 + n
    var date = new Date(year, month, num).getDate()
    var s = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
    return s
  }

/**
 * @description 得到本季度的起始、结束日期
 * @param {String} type s代表开始时间，e代表结束时间
 * @param {Number} n 不传或0代表本季度，-1代表上季度，1代表下季度
 */
 export function getQuater(type, n) {
    let currentQuarter = moment().quarter() // 当前是第几季度
    let currentYear = moment().year() // 当前年
    let getQuar = currentQuarter + n
    // 本季度开始
    if (type == 's') {
      let startMoth = moment(moment(currentYear + '-01-01').toDate()).quarter(getQuar)
      return moment(startMoth).format('YYYY-MM-DD')
    } else if (type == 'e') {
      let endMonth = 3 * parseInt(getQuar) //当季度最后一个月
      /* 对月数进行格式化 */
      if (endMonth < 10) endMonth = '0' + endMonth
      else endMonth += ''
      let endMonthDays = moment(currentYear + '-' + endMonth).daysInMonth() // 末尾月天数
      let endDays = currentYear + '-' + endMonth + '-' + endMonthDays //完整年月日整合
      return moment(endDays).format('YYYY-MM-DD')
    }
  }

/**
 * @description 得到今年、去年、明年的开始、结束日期
 * @param {String} type 有两种选择，"s"代表开始,"e"代表结束
 * @param {Number} dates 不传或0代表今年，-1代表去年，1代表明年
 */
export function getYear(type, dates) {
    const dd = new Date()
    const n = dates || 0
    const year = dd.getFullYear() + Number(n)
    let day
    if (type === 's') {
      day = `${year}-01-01`
    }
    if (type === 'e') {
      day = `${year}-12-31`
    }
    if (!type) {
      day = `${year}-01-01/${year}-12-31`
    }
    return day
  }


// WEBPACK FOOTER //
// ./src/utils/cycle.js